module.exports = {
  title: "觅特友",

  /** 固定顶部栏
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: false,

  /** 是否显示左侧栏logo
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: true,

  /** 是否显示顶部菜单栏
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarTopShow: true,

  /** 是否从后台获取左侧菜单
   * @type {boolean} true | false
   * @description
   */
  stateMenu: false // process.env.NODE_ENV === "development" ? false : true,
};
